import * as React from "react";
const SvgFiRrThirdMedal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15.667 17c0 1.654-1.346 3-3 3H10a1 1 0 1 1 0-2h2.667a1 1 0 0 0 0-2H11a1 1 0 1 1 0-2h1a1 1 0 0 0 0-2h-2a1 1 0 1 1 0-2h2c1.654 0 3 1.346 3 3 0 .608-.184 1.172-.496 1.646A2.98 2.98 0 0 1 15.667 17m6.639-14.131-3.243 6.57A8.95 8.95 0 0 1 21 14.999c0 4.963-4.037 9-9 9S3 19.963 3 15a8.95 8.95 0 0 1 1.951-5.579L1.718 2.87A1.98 1.98 0 0 1 1.813.938 1.98 1.98 0 0 1 3.502 0h3.009c1.534 0 2.909.854 3.588 2.23l1.86 3.772L12 6q.031.002.062.003l1.861-3.773A3.98 3.98 0 0 1 17.51 0h3.01c.692 0 1.324.351 1.689.938s.402 1.31.097 1.931M3.502 2l2.942 5.934A9 9 0 0 1 9.86 6.268L8.305 3.115A1.99 1.99 0 0 0 6.511 2zM19 15c0-3.859-3.141-7-7-7-.199 0-.394.014-.589.03h-.003C7.825 8.332 5 11.34 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7m1.512-13.015L17.511 2a1.99 1.99 0 0 0-1.794 1.115l-1.558 3.157a9 9 0 0 1 3.412 1.672z"
    />
  </svg>
);
export default SvgFiRrThirdMedal;
